module.exports = __webpack_public_path__ + "static/media/travel_category.ee2c41fc.jpg";